 
import { h, render, createElement } from 'preact'
import { onIntersectionOnce } from '@util/intersection'
import HeroCircle from '@components/hero-circle'
import ImageLoad from '@components/image-load'
import ScrollHeader from '@components/scroll-header'
import SiteNav from '@components/site-nav'
import SocialGrid from '@components/social-grid'
import Splash from '@components/splash'
import WhatWeDo from '@components/module-what-we-do'
import LightboxCarousel from '@components/lightbox-carousel'
import { ArticleGridLive, FiltersUrlLive } from '@components/article-grid'
import { FilterTaxonomiesLive } from '@components/filter-items'
import { ButtonIconArrowDownScroll } from '@components/button'
import VideoInline, { VideoInlineControls } from '@components/video-inline'

import { init as globe } from '@components/globe'
import carousel from '@components/module-carousel/client'
import tabbedContent from '@components/module-tabbed-content/client'
import lightboxCarousel from '@components/lightbox-carousel/client'
import modal from '@components/modal/client'


const componentsToHydrate = {
	ArticleGridLive,
	ButtonIconArrowDownScroll,
	FiltersUrlLive,
	HeroCircle,
	ImageLoad,
	ScrollHeader,
	SiteNav,
	SocialGrid,
	Splash,
	VideoInline,
	VideoInlineControls,
	WhatWeDo,
	LightboxCarousel,
	FilterTaxonomiesLive
}

const rehydrate = () => {

	const used = []

	// get hydration data and markers

	const data = JSON.parse(document.querySelector('script[type="hydration-data"]')?.innerHTML || false)
	const markers = [...document.querySelectorAll('script[type="marker"]')]

	// rehydrate individual components

	markers.forEach(marker => {
		const el = marker.nextElementSibling
		const id = marker.getAttribute('data-id')
		const props = data[id]?.props || {}
		const name = data[id]?.name || ''
		const Component = componentsToHydrate[name] || {}
		
		if (typeof Component !== 'function') {
			(ENVIRONMENT === 'development') && console.warn(`Can’t hydrate component with name "${name}", add it to the components list`)
			return false
		}

		used.push(name)
		onIntersectionOnce(
			el, () => render(createElement(Component, props), el.parentElement, el),
			'1500px'
		)
	})

	const unused = Object.keys(componentsToHydrate)
		.filter(componentName => used.indexOf(componentName) === -1)

	if (typeof Component !== 'function') {
		(ENVIRONMENT === 'development') && console.warn(`Unused components on page: ${unused.join(', ')}`)
	}
}



rehydrate()
globe()
carousel()
lightboxCarousel()
modal()
tabbedContent()